export interface IOption {
    value: string,
    label: string,
    hasAcceptableAnatomy: boolean
}